<template>
    <div>
        <v-dialog :value="loading" hide-overlay persistent width="300">
            <v-card color="primary" dark>
                <v-card-text>
                    Loading Data
                    <v-progress-linear
                            indeterminate
                            color="white"
                            class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog lazy v-model="message_dialog">
            <v-card>
                <v-card-title primary-title>
                    Enter message to send
                </v-card-title>
                <v-card-text>

                    <v-text-field type="textarea" label="Message" v-model="message"
                                  :rules="[val => !!val || 'Required Field']"/>

                    <v-btn color="primary" @click="sendMessage">
                        Send Message
                    </v-btn>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-container :fluid="true" v-if="user" style="padding:0">
            <v-layout column>
                <v-flex xs12 class="item">
                    <v-card color="secondary darken-1" class="white--text" style="padding: 10px 0">
                        <v-layout align-center>
                            <v-flex xs2>
                                <v-img :src="api.GET_IMAGE(user.profile_image)" height="125px" contain></v-img>
                            </v-flex>
                            <v-flex xs8>
                                <v-card-title primary-title>
                                    <div>
                                        <div class="headline">{{user.first_name + ' ' + user.last_name}}</div>
                                        <div>{{user.username}}</div>
                                        <div>{{user.email}}</div>
                                        <div>Join Date: {{moment(user.created_at).format('DD MMM YYYY')}}</div>
                                    </div>
                                </v-card-title>
                            </v-flex>
                            <v-flex md4 xs12>
                                <h3>Wallet: {{user.wallet}} S.P</h3>
                                <h3>
                                    <v-btn @click="message_dialog = true">Send Message</v-btn>
                                </h3>
                            </v-flex>
                        </v-layout>
                    </v-card>
                </v-flex>
                <v-flex xs12>
                    <v-tabs v-model="tab" color="secondary" grow>
                        <v-tabs-slider color="white"></v-tabs-slider>
                        <v-tab v-for="item in items" :key="item" :disabled="loading">
                            {{ item }}
                        </v-tab>
                        <v-tab-item>
                            <info provider="Passenger" :data="user"></info>
                        </v-tab-item>
                        <v-tab-item>
                            <v-card flat>
                                <v-card-text>STATS</v-card-text>
                            </v-card>
                        </v-tab-item>
                        <v-tab-item>
                            <bookings :id="$route.params.id"></bookings>
                        </v-tab-item>
                        <v-tab-item>
                            <transactions provider="passengers" :id="$route.params.id"/>
                        </v-tab-item>
                        <v-tab-item>
                            <notes provider="passengers" :id="$route.params.id"></notes>
                        </v-tab-item>
                    </v-tabs>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import moment from "moment";
    import notes from '@/components/profile/notes';
    import info from '@/components/profile/info';
    import bookings from '@/components/profile/passenger/passenger_bookings';
    import Transactions from "@/components/accounting/Transactions";

    export default {
        name: "passenger_profile",
        title: 'Passenger Profile',
        components: {notes, info, bookings, Transactions},
        data() {
            return {
                items: ['info', 'stats', 'bookings', 'accounting', 'notes'],
                tab: 0,
                loading: true,
                user: {},
                message_dialog: false,
                message: null
            };
        },
        mounted() {
            this.axios.get(`passenger/${this.$route.params.id}`)
                .then(({data}) => {
                        this.user = data.data;
                        this.loading = false;
                    }
                )
                .catch(err => console.log(err.message));
        },
        methods: {
            sendMessage() {
                this.loading = true;
                this.axios.put('broadcast', {
                    ids: [this.user.id],
                    broadcast: ['Whatsapp'],
                    message: this.message,
                    provider: 'passengers'
                }).then(
                    () => {
                        this.message_dialog = false;
                        window.getApp.$emit("SHOW_TOAST", "Tried");
                    }
                )
                    .finally(
                        () => this.loading = false
                    )
            },
            onFilePicked(e) {
                const files = e.target.files;
                if (files[0] !== undefined) {
                    this.imageName = files[0].name;
                    if (this.imageName.lastIndexOf('.') <= 0) {
                        return
                    }
                    const fr = new FileReader();
                    fr.readAsDataURL(files[0]);
                    fr.addEventListener('load', () => {
                        this.imageUrl = fr.result;
                        this.imageFile = files[0] // this is an image file that can be sent to server...
                    })
                } else {
                    this.imageName = '';
                    this.imageFile = '';
                    this.imageUrl = '';
                }
            },
            save() {
                if (this.$refs.form.validate()) {
                    const updatedData = Object.keys(this.user).filter(key => this.user[key] !== this.user[key]).map(item => ({[item]: this.user[item]}));
                    if (this.imageFile)
                        updatedData.push({profile_image: this.imageFile});
                    if (updatedData.length > 0) {
                        this.loading = true;
                        const formData = new FormData();
                        formData.append("_method", "PUT");
                        for (const field of updatedData) {
                            const key = Object.keys(field)[0];
                            formData.append(key, field[key]);
                        }
                        console.log(formData);
                        // this.axios.post(this.api.ACTIONS.USERS + '/' + this.user.id, formData)
                        //     .then(({data}) => {
                        //         this.imageName = '';
                        //         this.imageFile = '';
                        //         this.imageUrl = '';
                        //         this.user = data.data;
                        //         this.loading = false;
                        //         window.getApp.$emit('SHOW_TOAST', 'Saved');
                        //     });
                    }

                } else {
                    window.getApp.$emit("SHOW_TOAST", "Please check all fields", "red");
                }
            },
        },
        computed: {
            today() {
                return moment().format("YYYY-MM-DD");
            }
        }
    }

</script>

<style scoped>

</style>